import qs from 'qs';
import generateOrderInfoEndpoint from '../../lib/generateOrderInfoEndpoint';
import { processLabels, processOrderItems } from '../orderItems';
import { VALIDATE_POSTAL_CODE } from '../../constants/endpoints';
import { currencyCodeToSymbol } from '../../lib/currencyFormatters';

export const RECEIVE_ORDER_ERROR_INFO = 'RECEIVE_ORDER_ERROR_INFO';
export const RECEIVE_ORDER_DATA = 'RECEIVE_ORDER_DATA';
export const RESET_ORDER_INFO = 'RESET_ORDER_INFO';
export const RECEIVE_ORDER_CURRENCY = 'RECEIVE_ORDER_CURRENCY';
export const RECEIVE_RETURN_ORDER = 'RECEIVE_RETURN_ORDER';

export const receiveOrderCurrency =
  ({ orderLocale = '', orderCurrencyCode = '' }) =>
  (dispatch, getState) => {
    const {
      page: { locale },
    } = getState();
    const localeToFormatTo = orderLocale || locale;
    const orderCurrencySymbol = currencyCodeToSymbol(orderCurrencyCode, localeToFormatTo);
    dispatch({
      type: RECEIVE_ORDER_CURRENCY,
      data: {
        orderLocale,
        orderCurrencyCode,
        orderCurrencySymbol,
      },
    });
  };

export const validatePostalCode = (postalCode, invalidProvinces) => async (dispatch, getState) => {
  const {
    page: { browserFingerprint },
  } = getState();
  const params = qs.stringify({
    ozip: postalCode,
    restricted_states: invalidProvinces.join(','),
  });

  const response = await fetch(VALIDATE_POSTAL_CODE(params), {
    method: 'GET',
    headers: {
      'narvar-tfid': browserFingerprint,
    },
  });
  const { restricted, military } = await response.json();

  return !restricted && !military;
};

export const receiveOrderData = ({
  currentOrderNumber,
  orderLabels,
  customerInfo,
  orderData,
  shipByDate,
  validPostalCode,
  shipmentList,
}) => ({
  type: RECEIVE_ORDER_DATA,
  data: {
    currentOrderNumber,
    orderLabels,
    customerInfo,
    orderData,
    shipByDate,
    validPostalCode,
    shipmentList,
  },
});

export const requestOrderData = () => async (dispatch, getState) => {
  try {
    const {
      page: { productType, browserFingerprint } = {},
      returnsSettings: {
        [productType]: {
          multi_order: isMultiOrder = false,
          validation: {
            zip_validation_enabled: zipValidationEnabled = false,
            ineligible_states: invalidProvinces = [],
          } = {},
        } = {},
      } = {},
    } = getState();

    await dispatch({ type: RESET_ORDER_INFO });
    const response = await fetch(generateOrderInfoEndpoint(getState()), {
      method: 'GET',
      headers: {
        'narvar-tfid': browserFingerprint,
      },
    });
    const orderData = await response.json();

    const {
      order_info_items: orderItems,
      order_info: orderInfoFromApi = {},
      customer_info: customerInfoFromApi = {},
      error_response: {
        error_message: errorMessage,
        error_message_detail_code: errorMessageDetail,
      } = {},
      shipments_list: shipmentList = [],
    } = orderData;

    dispatch({
      type: RECEIVE_ORDER_ERROR_INFO,
      data: {
        errorMessage,
        errorMessageDetail,
      },
    });

    if (!orderInfoFromApi)
      throw new Error(errorMessageDetail || errorMessage || 'Missing Order Info');

    const {
      bzip_code: bzipCode,
      order_number: responseOrderNumber,
      ship_by_date: shipByDate,
      return_labels: orderBasedLabels = [],
    } = orderInfoFromApi;

    const customerInfo = customerInfoFromApi || {};
    const { customer_ref_number: customerInfoId = '', return_labels: customerBasedLabels = [] } =
      customerInfo;

    let validPostalCode = true;

    if (zipValidationEnabled || invalidProvinces.length) {
      validPostalCode = await validatePostalCode(bzipCode, invalidProvinces);
    }

    if (!validPostalCode) throw new Error('Invalid Postal Code or Province');

    await dispatch(
      receiveOrderData({
        currentOrderNumber: isMultiOrder ? customerInfoId : responseOrderNumber,
        orderLabels: isMultiOrder ? customerBasedLabels : orderBasedLabels,
        customerInfo,
        orderData,
        shipByDate,
        validPostalCode,
        shipmentList,
      }),
    );

    await dispatch(processOrderItems(orderItems));
    dispatch(processLabels(isMultiOrder ? customerBasedLabels : orderBasedLabels));
  } catch (err) {
    console.error(err); // eslint-disable-line no-console
  }
};
